import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AlertController, NavController, ModalController, LoadingController } from '@ionic/angular';

import { Salon } from '../../models/salon/salon.model';
import { Country } from '../../models/country/country.model';
import { UserService } from '../../services/user.service';
import { OnBoardingService } from '../../services/on-boarding.service';
import { SalonService } from '../../services/salon.service';
import { CountryService } from '../../services/country.service';
import { CustomValidator } from '../../utilities/custom-validator';
import { Utilities } from '../../utilities/utilities';
import { List } from 'immutable';
import { AlertService } from '../../utilities/alert.service';
import { ToastService } from '../../utilities/toast.service';
import {Router, ActivatedRoute} from '@angular/router';
@Component({
  selector: 'app-salon-profile',
  templateUrl: './salon-profile.page.html',
  styleUrls: ['./salon-profile.page.scss'],
})
export class SalonProfilePage implements OnInit {

  public isLoading: boolean;

  public errorOccurredWhileLoadingCountries: boolean;

  public submitted: boolean;

  public salon: Salon;

  public salonProfileForm: UntypedFormGroup;

  public salonName: UntypedFormControl;

  public phone: UntypedFormControl;

  public fax: UntypedFormControl;

  public email: UntypedFormControl;

  public address1: UntypedFormControl;

  public address2: UntypedFormControl;

  public city: UntypedFormControl;

  public province: UntypedFormControl;

  public postal: UntypedFormControl;

  public country: UntypedFormControl;

  public website: UntypedFormControl;

  public countries: List<Country>;

  public modal: boolean;

  public isAdmin: boolean;

  constructor(
    //private navCtrl: NavController,
    private userService: UserService,
    private countryService: CountryService,
    private onBoardingService: OnBoardingService,
    private formBuilder: UntypedFormBuilder,
    private alertCtrl: AlertController,
    private salonService: SalonService,
    //private navParams: NavParams,
    private modalController: ModalController,
    private readonly alertService: AlertService,
    private loadingCtrl: LoadingController,
    private readonly toastService: ToastService,
    private router: Router,) {
      this.salon = userService.getSalon().clone();
     // this.modal = this.navParams.get('modal');
      this.isAdmin = this.userService.getUser().isAdministrator();
      this.isLoading = false;
      this.submitted = false;
      this.salonName = new UntypedFormControl(this.salon.getName(), Validators.compose([Validators.required, Validators.maxLength(100)]));
      // allow looser phone validation because user may change country and we don't want to restrict their phone number if we're validating against the wrong country
      this.phone = new UntypedFormControl(this.salon.getPhone(), Validators.compose([Validators.maxLength(20), CustomValidator.validatePhone(0)]));
      this.fax = new UntypedFormControl(this.salon.getFax(), Validators.maxLength(20));
      this.email = new UntypedFormControl(this.salon.getEmail(), Validators.compose([Validators.maxLength(100), CustomValidator.validateEmail]));
      this.address1 = new UntypedFormControl(this.salon.getAddress1(), Validators.maxLength(40));
      this.address2 = new UntypedFormControl(this.salon.getAddress2(), Validators.maxLength(40));
      this.city = new UntypedFormControl(this.salon.getCity(), Validators.maxLength(20));
      this.province = new UntypedFormControl(this.salon.getProvince(), Validators.maxLength(25));
      this.postal = new UntypedFormControl(this.salon.getPostal(), Validators.maxLength(7));
      this.country = new UntypedFormControl((this.salon.getCountry()) ? this.salon.getCountry().getID() : null);
      this.website = new UntypedFormControl(this.salon.getWebsite(), Validators.maxLength(100));
      this.salonProfileForm = this.formBuilder.group({
        salonName: this.salonName,
        phone: this.phone,
        fax: this.fax,
        email: this.email,
        address1: this.address1,
        address2: this.address2,
        city: this.city,
        province: this.province,
        postal: this.postal,
        country: this.country,
        website: this.website
      });

    }

  ngOnInit() {
    this.loadCountries();

    this.onBoardingService.getStylistOnBoarding()
      .subscribe((stylistOnboarding) => {

        if (this.onBoardingService.isBusinessDetailsOnboardingDone()) {
          return;
        }
        
        stylistOnboarding = stylistOnboarding.setBusinessDetails(1);
        this.onBoardingService.save(stylistOnboarding)
          .subscribe((onboarding) => {});
      });
  }

  public loadCountries () {
    this.isLoading = true;
    this.errorOccurredWhileLoadingCountries = false;
    this.countryService.getCountries()
      .subscribe({
          next: (countries) => {
            this.countries = countries;
            this.isLoading = false;
          },
          error: (error) => {
            this.alertService.presentErrorAlert();
            this.isLoading = false;
            this.errorOccurredWhileLoadingCountries = true;
          },
          complete: () => console.info('Fetched all countries')
      });
  }

  public async onSalonProfileSave () {
    this.submitted = true;

    if (this.salonProfileForm.valid === false) {
      return;
    }

    let newCountry: Country;
    this.countries
      .filter((country: Country) => country.getID() === this.country.value)
      .map((country: Country) => {
        newCountry = country;
      });

    this.salon = this.salon.setName(this.salonName.value);
    this.salon = this.salon.setPhone(this.phone.value);
    this.salon = this.salon.setFax(this.fax.value);
    this.salon = this.salon.setEmail(this.email.value);
    this.salon = this.salon.setAddress1(this.address1.value);
    this.salon = this.salon.setAddress2(this.address2.value);
    this.salon = this.salon.setCity(this.city.value);
    this.salon = this.salon.setProvince(this.province.value);
    this.salon = this.salon.setPostal(this.postal.value);
    this.salon = this.salon.setCountry(newCountry);
    this.salon = this.salon.setWebsite(this.website.value);
  
    const loader = await this.loadingCtrl.create({
        spinner: 'crescent',
      });

      loader.present();
    this.salonService.saveSalon(this.salon)
      .subscribe({
        next: (result) => {
          this.salon = result;
          this.submitted = false;
          this.userService.setSalon(this.salon);
          this.toastService.presentSimpleToast(`Salon profile has been successfully updated.`, 3000);

          loader.dismiss().then(() => {
            if (this.modal) {
              // Not sure why we do this - why would we have a modal here?
              this.modalController.dismiss(this.salon);
            } else {
              this.router.navigateByUrl('/settings');
            }
          });
        },
        error: (e) => {
          loader.dismiss().then(() => {
            this.alertService.presentErrorAlert();
          });
        }      
      });
  }

  public onDismiss () {
    // Not sure why we do this
    this.modalController.dismiss();
  }

}